"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressColor = void 0;
var ProgressColor = exports.ProgressColor = Object.freeze({
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  INVERSE: 'inverse'
});